import MiniGraph from './MiniGraph';

export * from './MiniGraph';
export default MiniGraph;
